
jQuery(function($) {
  

      // niceselect pour les cats 
 $('.to_nicedropdowncat-js').niceSelect();

  $('.ActionToChild-js').on('change', function() {
    document.location=this.value;
  });




    /* ******************* */
   /* CLASS / BTNSCROLL ANCHOR */
   /* ******************* */

    $('.btnAnchor').click(function(e){

    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top - 60;
  
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 600);
     
      e.preventDefault();
  });



  


  /////////////////////////////////////
 	 //////// CLICK ON SEARCHTAB ////////
   var $btn_close_form = $('.js-close-form');
   var $btn_open_mobile = $('.js-mobile-open-search');
   $('li.item_recherche > a, .js-mobile-open-form').on('click', function(evt) { // Au clic sur un élément
    
    $('body').toggleClass('toggle_search'); // Go
    
    if($btn_close_form.attr('aria-expanded') == 'false'){
       $btn_close_form.attr('aria-expanded','true');
    }else{
      $btn_close_form.attr('aria-expanded','false');
    }

     if($btn_open_mobile.attr('aria-expanded') == 'false'){
       $btn_open_mobile.attr('aria-expanded','true');
    }else{
      $btn_open_mobile.attr('aria-expanded','false');
    }

      evt.preventDefault();
    });

   /// CLOSE SEARCH 
    $( ".js-close-form" ).click(function( ) {
          $(this).attr('aria-expanded','false');
          $('body').toggleClass('toggle_search'); // Go
  });	 


  /* **************************************************  */
  /* GALERY DANS LES POSTS OU REALISATIONS */
  /* **************************************************  */

   $("#lightgallery").lightGallery({
       subHtmlSelectorRelative: true
  }); 



  $(".wysiwyg .gallery").lightGallery({
      selector:'a',
      subHtmlSelectorRelative: true
  }); 




  /* **************************************************  */
  /* SLIDER ONLY MOBILE */
  /* **************************************************  */

  $slick_slider = $('.HomePostResume-SliderMobile');
  settings_slider = {
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows:true,
  dots: true,
  responsive: [
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows:true,
        dots: true,
      }
    }
  ]
    // more settings
  };

  slick_on_mobile( $slick_slider, settings_slider);

// slick on mobile
  function slick_on_mobile(slider, settings){
    $(window).on('load resize', function() {
      if ($(window).width() > 1023) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return;
      }
      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  }
  


   // /*  ***************************
  //  SLIDER TOP ACCUEIL
  // ******************************** */

    $('.HomeIntroSlider-js').slick({
        //setting-name: setting-value
        dots: true,
       // infinite:true,
        arrows:false,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:900,
        fade: true,
        pauseOnHover:false,
        pauseOnFocus:false,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows:false,
            dots: true
        }
       }
      ]
   });


    // /*  ***************************
  //  SLIDER SINGLE ITEM MODELE
  // ******************************** */

    $('.SingleSliderModele-js').slick({
        //setting-name: setting-value
        dots: false,
       // infinite:true,
        arrows:true,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:900,
        fade: true,
        pauseOnHover:false,
        pauseOnFocus:false,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows:false,
            dots: true
        }
       }
      ]
   });


      $(".lightgallery, .js-lightgallery").lightGallery({
          subHtmlSelectorRelative: true,
          selector:'a',
    }); 

    // Infinite scroll dans les catégories

    $('.list-infinite-post').infiniteScroll({
        path: '.pagination__next',
        append: '.grid-item',
        status: '.page-load-status',
        hideNav: '.pagination__next',
        history:false // ne change pas l'url
       
    });  



 });